import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-unread-count-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './unread-count-badge.component.html',
  styleUrls: ['./unread-count-badge.component.scss'],
})
export class UnreadCountBadgeComponent {
  @Input() count = 0;

  get displayCount(): string {
    return `${this.count}`;
  }
}
